export const tryVibrate = (duration=200) => {
  if (navigator.vibrate)
    navigator.vibrate(duration);  // vibrate if device supports it
}
